import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileService } from 'src/app/core/file.service';

@Component({
  selector: 'app-file-upload-area',
  templateUrl: './file-upload-area.component.html',
  styleUrls: ['./file-upload-area.component.scss'],
  standalone: false
})
export class FileUploadAreaComponent {

  @Input() title?: string;
  @Input() text?: string;
  @Input() showFilePreview: boolean = false;
  @Input() uploadedFiles: File[] = [];
  @Output() filesChanged = new EventEmitter<File[]>(); // Emit files
  isDragging = false;

  constructor(private fileService: FileService) {}

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  
    if (event.dataTransfer?.files) {
      const validFiles = Array.from(event.dataTransfer.files).filter(file =>
        file.type === 'application/pdf'
      );
      this.uploadedFiles = [...this.uploadedFiles, ...validFiles];
      this.emitFiles();
    }
  }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const filesArray = Array.from(input.files);
      this.uploadedFiles = [...this.uploadedFiles, ...filesArray];
      this.emitFiles();
    }
  }

  private emitFiles(): void {
    this.filesChanged.emit(this.uploadedFiles);
  }
}